import { ReactComponent as InfoSvg } from "@/src/assets/icons/icon-info-blue4.svg";
import { Button } from "@/src/components/atom/Button";
import Typo from "@/src/components/atom/Typo";
import CallOut from "@/src/components/molecule/CallOut";
import Flex from "@/src/components/molecule/Flex";
import colorSet from "@/src/styles/color";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

interface PONoticeCallOutProps {
  onCreatePO?: () => void;
  isLoading?: boolean;
  isDisabled?: boolean;
  errorMessage?: string;
  variant?: "default" | "error";
}

function PONoticeCallOut({
  onCreatePO,
  isLoading = false,
  isDisabled = false,
  errorMessage,
  variant = "default",
}: PONoticeCallOutProps) {
  const { t } = useTranslation();

  const isError = variant === "error" || !!errorMessage;
  const backgroundColor = isError ? "red8" : "systemBlue6";
  const borderColor = isError ? "red7" : "systemBlue5";
  const textColor = isError ? "red2" : "systemBlue2";

  return (
    <StyledCallOut backgroundColor={backgroundColor} borderColor={borderColor}>
      <InfoIcon $color={textColor} />
      <Flex
        alignItems="center"
        justifyContent="space-between"
        isFullWidth
        gap={8}
      >
        <MessageContainer flexDirection="column" gap={4}>
          <Typo color={textColor} typoType="b7m">
            {t("contract:po.notice.title")}
          </Typo>
          <Typo color={textColor} typoType="b9r">
            {errorMessage || t("contract:po.notice.message")}
          </Typo>
        </MessageContainer>

        {onCreatePO && (
          <Button
            buttonColor="blue"
            buttonGrade="primary"
            buttonSize={32}
            onClick={onCreatePO}
            isLoading={isLoading}
            disabled={isDisabled || isLoading}
          >
            {t("contract:po.notice.button")}
          </Button>
        )}
      </Flex>
    </StyledCallOut>
  );
}

export default PONoticeCallOut;

const StyledCallOut = styled(CallOut)`
  align-items: center;
  padding: 12px 16px;
`;

const InfoIcon = styled(InfoSvg)<{ $color: keyof typeof colorSet }>`
  width: 16px;
  height: 16px;
  flex-shrink: 0;

  * {
    fill: ${({ $color }) => colorSet[$color]};
  }
`;

const MessageContainer = styled(Flex)`
  flex: 1;
`;